import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { AdministradoraListarComponent } from './administradora-listar.component';
import { AdministradoraListarRoutingModule } from './administradora-listar-routing.module';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { RippleModule } from 'primeng/ripple';
import { ChipModule } from 'primeng/chip';
import { EditorModule } from 'primeng/editor';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
 
  imports: [
    AdministradoraListarRoutingModule,
     CommonModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    FileUploadModule,
    RippleModule,        
    ChipModule,
    TableModule,
    EditorModule,
    HttpClientModule,        
    TooltipModule,
    DividerModule,
    SplitButtonModule,
    ConfirmDialogModule,
    ProgressSpinnerModule
    
  ],
  providers: [
    ConfirmationService
  ],
  declarations: [
    AdministradoraListarComponent
  ]
})
export class AdministradoraListarModule { }
